export type MunilyAlertType = 'error' | 'info' | 'warning';

export const MUNILY_ALERT_DEFAULTS = {
  type: 'info' as MunilyAlertType,
  showDescription: true,
  emphasisText: '',
  description: '',
  widthLayout: 'fixed' as MunilyAlertWidthLayout,
  richText: true,
};

export type MunilyAlertWidthLayout = 'fixed' | 'fill';

